// extracted by mini-css-extract-plugin
export default {"badgeHeight":"fgLw9y","badgeBorder":"YRrV65"};